import { put, call, takeLatest, all } from 'redux-saga/effects';
import CowAPI from '../cows/CowAPI';
import {
  fetchAnimalSuccess,
  fetchAnimalFail } from './actions';
import { showNotification } from '../notifications/actions';
import { parseApiError } from '../util/api';
import { GBI_ANIMAL_FETCH } from './constants';
import ScoreAdminAPI from '../admin/scoreDefinitions/ScoreAdminAPI';

function *fetchAnimal (action) {
  try {
    const [ animalResponse, scoresResponse ] = yield all([
      call(CowAPI.fetchById, action.id),
      call(ScoreAdminAPI.fetchScores)
    ]);
    const scoreDefinitions = {};
    scoresResponse.data.scores.forEach(score => {
      scoreDefinitions[score.key] = score;
    });
    yield put(fetchAnimalSuccess(animalResponse.data, scoreDefinitions));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchAnimalFail(msg, action.id));
    yield put(showNotification(
      'Failed to load animial details', msg, 'error', 20
    ));
  }
}

function *animalSagas () {
  yield takeLatest(GBI_ANIMAL_FETCH, fetchAnimal);
}

export default animalSagas;
